export default {
  Normal: '0',
  SpecRate: '1',
  AudaNetPart: '2',
  NonAudaNetPart: '3'
}
